/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import {
  getCurrentInstance,
  ref,
  watchEffect,
} from 'vue'
import {
  createI18n,
  useI18n,
} from 'vue-i18n'

import en_US from './en-US.json'
import ID from './id.json'
import JA from './ja.json'
import KO from './ko.json'
import MS from './ms.json'
import zh_CN from './zh-CN.json'
import zh_TW from './zh-TW.json'

export enum SupportLocale {
  EN_US = 'en-US',
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
  'ID' = 'id',
  'MS' = 'ms',
  'KO' = 'ko',
  'JA' = 'ja',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const messages: Record<SupportLocale, any> = {
  [SupportLocale.EN_US]: en_US,
  [SupportLocale.ZH_CN]: zh_CN,
  [SupportLocale.ZH_TW]: zh_TW,
  [SupportLocale.ID]: ID,
  [SupportLocale.JA]: JA,
  [SupportLocale.KO]: KO,
  [SupportLocale.MS]: MS,
}

const lazyLoadLocaleJsonFile = (locale: SupportLocale) => {
  const message = messages[locale] || messages[SupportLocale.EN_US]
  for (const prop in message) {
    try {
      message[prop] = message[prop]
        .replaceAll('PikPak', 'FilePax')
        .replaceAll('mypikpak', 'filepax')
        .replaceAll('PIKCLOUD PTE. LTD.', 'PaxCloud Limited')
        .replaceAll('PIKCLOUD', 'PaxCloud')
        .replaceAll('픽팍', '파일 팍스')
    } catch (err) {
      console.error(err)
    }
  }
  return message
}

// 使用独立的实例
const i18n = createI18n({
  legacy: false,
  locale: SupportLocale.EN_US,
  fallbackLocale: messages[SupportLocale.EN_US],
  messages,
})

// @ts-ignore
export const t = i18n.global.t

export const setLocale = (lang: SupportLocale, isFilePax: boolean) => {
  if (!messages[lang]) {
    lang = SupportLocale.EN_US
  }

  let message_ = messages[lang]
  if (isFilePax) {
    message_ = lazyLoadLocaleJsonFile(lang)
  }

  i18n.global.setLocaleMessage(lang, message_)
  i18n.global.locale.value = lang
}

export const useI18n4FileManager = (props: { lang?: SupportLocale; isFilePax?: boolean }) => {
  const instance = getCurrentInstance()
  let locale = ref('')

  if (instance?.appContext.app) {
    // eslint-disable-next-line vue/no-ref-as-operand
    locale = useI18n().locale
  }

  watchEffect(() => {
    const nextLang = props?.lang || locale.value
    setLocale(nextLang as SupportLocale, !!props.isFilePax)
  })

  return {
    // @ts-ignore
    t: i18n.global.t,
    locale,
  }
}

export default i18n
